<template>
  <div >
    <div class="cropper-content">
      <!-- 剪裁框 -->
      <div class="cropper">
        <vueCropper ref="cropper" :img="option.img" :outputSize="option.size" :outputType="option.outputType"
                    :info="true" :full="option.full" :canMove="option.canMove" :canMoveBox="option.canMoveBox"
                    :original="option.original" :autoCrop="option.autoCrop" :autoCropWidth="option.autoCropWidth"
                    :autoCropHeight="option.autoCropHeight" :fixedBox="option.fixedBox" :canScale="option.canScale"
                    :centerBox="option.centerBox" :fixed="option.fixed" :fixedNumber="fixedNumber"
                    @realTime="realTime"></vueCropper>
      </div>
      <!-- 预览框 -->
      <div class="show-preview"
           :style="{width: '500px',height: '400px',overflow: 'hidden',margin: '0 25px',display: 'flex','align-items': 'center',}">
        <div :style="previews.div" class="preview">
          <img :src="previews.url" :style="previews.img"/>
        </div>
      </div>
    </div>
    <div class="footer-btn">
      <!-- 缩放旋转按钮 -->
      <div class="scope-btn">
        <el-button type="primary" :icon="Plus" @click="changeScale(1)"></el-button>
        <el-button type="primary" :icon="Minus" @click="changeScale(-1)"></el-button>
        <el-button type="primary" @click="changeRotate(1)">逆时针旋转</el-button>
        <el-button type="primary" @click="changeRotate(2)">顺时针旋转</el-button>
      </div>
      <!-- 确认上传按钮 -->
      <div class="upload-btn">
        <el-button type="primary" @click="uploadImg('blob')">上传</el-button>
      </div>
    </div>
  </div>
</template>

<script setup>
import "vue-cropper/dist/index.css";
import { VueCropper } from "vue-cropper";
import { ref, watch } from "vue";
import { Plus, Minus } from "@element-plus/icons-vue";

const emit = defineEmits()

const cropper = ref(null);
const option = ref({
  img: "", // 裁剪图片的地址  (默认：空)
  outputSize: 1, // 裁剪生成图片的质量  (默认:1)
  full: false, // 是否输出原图比例的截图 选true生成的图片会非常大  (默认:false)
  outputType: "png", // 裁剪生成图片的格式  (默认:jpg)
  canMove: true, // 上传图片是否可以移动  (默认:true)
  original: false, // 上传图片按照原始比例渲染  (默认:false)
  canScale: true, //图片是否允许滚轮缩放
  canMoveBox: true, // 截图框能否拖动  (默认:true)
  autoCrop: true, // 是否默认生成截图框  (默认:false)
  autoCropWidth: 4800, // 默认生成截图框宽度  (默认:80%)
  autoCropHeight: 320, // 默认生成截图框高度  (默认:80%)
  fixedBox: false, // 固定截图框大小 不允许改变  (默认:false)
  fixed: true, // 是否开启截图框宽高固定比例  (默认:true)
  enlarge: 1, //图片根据截图框输出比例倍数
  centerBox: true, // 裁剪框是否限制在图片内
});

const props = defineProps({
  imgFile: {
    type: String,
  },
  fixedNumber: {
    type: Array,
  },
});

const previews = ref({
  // 剪裁框比例设置
  default: function () {
    return [1.5, 2];
  },
});

const realTime = (data) => {
  // 实时预览
  previews.value = data;
};

// 修改照片缩放
const changeScale = (num) => {
  num = num || 1;
  cropper.value.changeScale(num);
};

/**
 * @description: 照片旋转
 * @param {*} type  1: 逆时针  2: 顺时针
 * @return {*}
 */
const changeRotate = (type) => {
  if (type === 1) {
    cropper.value.rotateLeft();
  } else {
    cropper.value.rotateRight();
  }
};

// 回传裁剪好的图片
const uploadImg = (type) => {
  event.preventDefault();
  if (type === "blob") {
    cropper.value.getCropBlob((data) => {
      emit("upload", data);
    });
  } else {
    cropper.value.getCropData((data) => {
      emit("upload", data);
    });
  }
};

watch(
  () => props.imgFile,
  (val) => {
    option.value.img = props.imgFile;
  },
  { deep: true, immediate: true }
);
</script>

<style lang="scss" scoped>
.cropper-content {
  display: flex;
  display: -webkit-flex;
  justify-content: flex-end;
  -webkit-justify-content: flex-end;
}

.cropper-content .cropper {
  width: 500px;
  height: 400px;
}

.cropper-content .show-preview {
  flex: 1;
  -webkit-flex: 1;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  -webkit-justify-content: center;
  overflow: hidden;
  border: 1px solid #cccccc;
  background: #cccccc;
  margin-left: 40px;
}

.preview {
  overflow: hidden;
  border: 1px solid #cccccc;
  background: #cccccc;
}

.footer-btn {
  margin-top: 30px;
  display: flex;
  display: -webkit-flex;
  justify-content: flex-end;
  -webkit-justify-content: flex-end;
}

.footer-btn .scope-btn {
  width: 420px;
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  -webkit-justify-content: space-between;
}

.footer-btn .upload-btn {
  flex: 1;
  -webkit-flex: 1;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  -webkit-justify-content: center;
}

.footer-btn .btn {
  outline: none;
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  -webkit-appearance: none;
  text-align: center;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  outline: 0;
  margin: 0;
  -webkit-transition: 0.1s;
  transition: 0.1s;
  font-weight: 500;
  padding: 8px 15px;
  font-size: 12px;
  border-radius: 3px;
  color: #fff;
  background-color: #67c23a;
  border-color: #67c23a;
}
</style>
